import { disposePubNub } from '../actions/pubnub/init';
import { reportInitialState } from '../store/initialState';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const UPDATED_HIDE_WHEN_CLICK_AWAY_QUICK_VIEW = 'UPDATED_HIDE_WHEN_CLICK_AWAY_QUICK_VIEW';
export const UPDATED_SHOW_QUICK_VIEW_MODAL = 'UPDATED_SHOW_QUICK_VIEW_MODAL';
export const UPDATED_SHOW_CREATE_WAITING_AREA_MODAL = 'UPDATED_SHOW_CREATE_WAITING_AREA_MODAL';
export const UPDATED_SHOW_UPDATE_WAITING_AREA_MODAL = 'UPDATED_SHOW_UPDATE_WAITING_AREA_MODAL';
export const UPDATED_SHOW_VIEW_WAITING_AREA_MODAL = 'UPDATED_SHOW_VIEW_WAITING_AREA_MODAL';
export const UPDATED_SHOW_VIEW_MEETING_ROOM_PARTICIPANT = 'UPDATED_SHOW_VIEW_MEETING_ROOM_PARTICIPANT';
export const UPDATED_SHOW_VIEW_WA_INVITE_SELF_PROVISION = 'UPDATED_SHOW_VIEW_WA_INVITE_SELF_PROVISION';
export const EDIT_UPDATE_PORTAL_SETTING = 'EDIT_UPDATE_PORTAL_SETTING';
export const UPDATED_SHOW_REGISTERED_USER_WITH_WA_MODAL = 'UPDATED_SHOW_REGISTERED_USER_WITH_WA_MODAL';
export const UPDATED_SHOW_WA_WELCOME_MODAL = 'UPDATED_SHOW_WA_WELCOME_MODAL';
export const UPDATED_SHOW_MY_ROLES_MODAL = 'UPDATED_SHOW_MY_ROLES_MODAL';

export const UPDATED_SHOW_UPDATE_WAITING_AREA_OPERATING_HOURS_MODAL =
  'UPDATED_SHOW_UPDATE_WAITING_AREA_OPERATING_HOURS_MODAL';
export const UPDATED_SHOW_VIEW_WAITING_AREA_OPERATING_HOURS_MODAL =
  'UPDATED_SHOW_VIEW_WAITING_AREA_OPERATING_HOURS_MODAL';

export const UPDATED_SHOW_UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL =
  'UPDATED_SHOW_UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL';
export const UPDATED_SHOW_VIEW_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL =
  'UPDATED_SHOW_VIEW_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL';

export const UPDATED_SHOW_WAITING_AREA_LOGO_PAUSE_IMAGE_MODAL = 'UPDATED_SHOW_WAITING_AREA_LOGO_PAUSE_IMAGE_MODAL';
export const UPDATED_SHOW_ORGANISATIONAL_UNIT_LOGO_IMAGE_MODAL = 'UPDATED_SHOW_ORGANISATIONAL_UNIT_LOGO_IMAGE_MODAL';

export const UPDATED_SHOW_WEBSITE_BUTTON_WAITING_AREA_MODAL = 'UPDATED_SHOW_WEBSITE_BUTTON_WAITING_AREA_MODAL';
export const UPDATED_SHOW_CREATE_MEETING_ROOM_MODAL = 'UPDATED_SHOW_CREATE_MEETING_ROOM_MODAL';
export const UPDATED_SHOW_UPDATE_MEETING_ROOM_MODAL = 'UPDATED_SHOW_UPDATE_MEETING_ROOM_MODAL';
export const UPDATED_SHOW_VIEW_MEETING_ROOM_MODAL = 'UPDATED_SHOW_VIEW_MEETING_ROOM_MODAL';
// Edit meeting room Properties
export const SHOW_EDIT_MEETING_ROOM_MODAL = 'SHOW_EDIT_MEETING_ROOM_MODAL';
export const UPDATED_SHOW_DELETE_MEETING_ROOM_MODAL = 'UPDATED_SHOW_DELETE_MEETING_ROOM_MODAL';
export const UPDATE_SHOW_INVITE_GUEST_MODAL = 'UPDATE_SHOW_INVITE_GUEST_MODAL';
export const UPDATED_SHOW_VIEW_WAITING_AREA_PARTICIPANT = 'UPDATED_SHOW_VIEW_MEETING_ROOM_MODAL';
export const UPDATED_SHOW_NOTIFY_ROOM_PARTICIPANT = 'UPDATED_SHOW_NOTIFY_ROOM_PARTICIPANT';
export const SHOW_CALL_HISTORY_MODAL = 'SHOW_CALL_HISTORY_MODAL';
export const UPDATE_SHOW_FORGET_PASSWORD_MODAL = 'UPDATE_SHOW_FORGET_PASSWORD_MODAL';
export const UPDATE_SHOW_RESET_PASSWORD_TOKEN_MODAL = 'UPDATE_SHOW_RESET_PASSWORD_TOKEN_MODAL';
export const UPDATED_SHOW_ADD_TO_CALL_WAITING_ARE_MODAL = 'UPDATED_SHOW_ADD_TO_CALL_WAITING_ARE_MODAL';
export const UPDATED_SHOW_UPDATE_SMS_NOTIFICATION = 'UPDATED_SHOW_UPDATE_SMS_NOTIFICATION';
export const UPDATED_SHOW_CREATE_SMS_NOTIFICATION = 'UPDATED_SHOW_CREATE_SMS_NOTIFICATION';
export const UPDATE_SHOW_CHANGE_PASSWORD_MODAL = 'UPDATE_SHOW_CHANGE_PASSWORD_MODAL';
export const UPDATE_SHOW_CHANGE_EMAIL_MODAL = 'UPDATE_SHOW_CHANGE_EMAIL_MODAL';
export const UPDATE_SHOW_CHANGE_EMAIL_SUCCESS_MODAL = 'UPDATE_SHOW_CHANGE_EMAIL_SUCCESS_MODAL';
export const UPDATE_SHOW_USER_PROFILE_MODAL = 'UPDATE_SHOW_USER_PROFILE_MODAL';
export const UPDATE_SHOW_SUSPEND_WA_MODAL = 'UPDATE_SHOW_SUSPEND_WA_MODAL';
export const UPDATE_SHOW_WA_SHARE_LINK_MSG_MODAL = 'UPDATE_SHOW_WA_SHARE_LINK_MSG_MODAL';
export const UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_MODAL = 'UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_MODAL';
export const UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO_MODAL =
  'UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO_MODAL';
export const UPDATE_SHOW_DURING_CALLS_MODAL = 'UPDATE_SHOW_DURING_CALLS_MODAL';
export const UPDATE_SHOW_CALLER_ENTRY_POINT = 'UPDATE_SHOW_CALLER_ENTRY_POINT';
export const UPDATED_SHOW_WAITING_AREA_AFTER_CALLS_MODAL = 'UPDATED_SHOW_WAITING_AREA_AFTER_CALLS_MODAL';
export const UPDATED_SHOW_WAITING_AREA_ADD_USER_MODAL = 'UPDATED_SHOW_WAITING_AREA_ADD_USER_MODAL';
export const UPDATED_SHOW_ORGANISATIONAL_UNIT_ADD_USER_MODAL = 'UPDATED_SHOW_ORGANISATIONAL_UNIT_ADD_USER_MODAL';
export const UPDATE_SHOW_SET_MIN_DURATIONS_MODAL = 'UPDATE_SHOW_SET_MIN_DURATIONS_MODAL';
export const SHOW_CONSULT_NOW_SETTING_MODAL = 'SHOW_CONSULT_NOW_SETTING_MODAL';
export const SHOW_WA_AUDIO_SETTING_MODAL = 'SHOW_WA_AUDIO_SETTING_MODAL';

/************************************* Meeting Rooms ******************************************/
export const SHOW_COPY_LINK_TO_CLIPBOARD_MODAL_FOR_MEETING_ROOM = 'SHOW_COPY_LINK_TO_CLIPBOARD_MODAL_FOR_MEETING_ROOM';

// Manage roles in users list
export const SHOW_MANAGE_ROLES_FOR_USERS = 'SHOW_MANAGE_ROLES_FOR_USERS';

// Supoort contact
export const SHOW_SUPPORT_CONTACT_MODAL = 'SHOW_SUPPORT_CONTACT_MODAL';
export const SHOW_INFO_FOR_CALLERS_MODAL = 'SHOW_INFO_FOR_CALLERS_MODAL';
// Delete Waiting Area
export const SHOW_DELETE_WA_MODAL = 'SHOW_DELETE_WA_MODAL';
// Manange tags
export const SHOW_REMOVE_TAG_CONFIRMATION_MODAL = 'SHOW_REMOVE_TAG_CONFIRMATION_MODAL';
export const SHOW_ASSIGN_TAGS_MODAL = 'SHOW_ASSIGN_TAGS_MODAL';
export const SHOW_EDIT_TAG_VALUE_MODAL = 'SHOW_EDIT_TAG_VALUE_MODAL';

// OU Manange tags
export const SHOW_REMOVE_TAG_CONFIRMATION_MODAL_IN_OU = 'SHOW_REMOVE_TAG_CONFIRMATION_MODAL_IN_OU';
export const SHOW_ASSIGN_TAGS_MODAL_IN_OU = 'SHOW_ASSIGN_TAGS_MODAL_IN_OU';
export const SHOW_EDIT_TAG_VALUE_MODAL_IN_OU = 'SHOW_EDIT_TAG_VALUE_MODAL_IN_OU';

//OU MANAGE USER
export const SHOW_ORG_MANAGE_ROLES_FOR_USERS = 'SHOW_ORG_MANAGE_ROLES_FOR_USERS';

// Org Units
export const SHOW_ORG_UNIT_GENERAL_INFO_MODALS = 'SHOW_ORG_UNIT_GENERAL_INFO_MODALS';
export const SHOW_ORG_UNIT_SUPPORT_CONTACT_MODAL = 'SHOW_ORG_UNIT_SUPPORT_CONTACT_MODAL';
export const SHOW_ORG_UNIT_BEFORE_CALLS_WA_MODAL = 'SHOW_ORG_UNIT_BEFORE_CALLS_WA_MODAL';
export const SHOW_ORG_UNIT_SHARE_LINK_WA_MODAL = 'SHOW_ORG_UNIT_SHARE_LINK_WA_MODAL';
export const SHOW_RECORDING_SETTING_MODAL = 'SHOW_RECORDING_SETTING_MODAL';

// Meeting room
export const SHOW_MEETING_ROOM_RESET_GUEST_LINK_MODAL = 'SHOW_MEETING_ROOM_RESET_GUEST_LINK_MODAL';
// Meeting Room Add users
export const SHOW_MEETING_ROOM_ADD_USERS_MODAL = 'SHOW_MEETING_ROOM_ADD_USERS_MODAL';
export const SHOW_MR_MANAGE_ROLES_FOR_USERS = 'SHOW_MR_MANAGE_ROLES_FOR_USERS';

// Manage all users listing page
export const SHOW_OTHER_USERS_PROFILE = 'SHOW_OTHER_USERS_PROFILE';
// Show other user's roles
export const SHOW_OTHER_USERS_ROLES = 'SHOW_OTHER_USERS_ROLES';
// Create OU
export const SHOW_CREATE_OU_MODAL = 'SHOW_CREATE_OU_MODAL';
// Manage Invitations
export const SHOW_MANAGE_INVITATIONS_MODAL = 'SHOW_MANAGE_INVITATIONS_MODAL';

// Share URL in PiWA
export const SHOW_SHARE_BY_EMAIL_WA = 'SHOW_SHARE_BY_EMAIL_WA';
export const SHOW_SHARE_BY_TEXT_WA = 'SHOW_SHARE_BY_TEXT_WA';

export const SHOW_CONFIRMATION_CALL_MESS_MODAL = 'SHOW_CONFIRMATION_CALL_MESS_MODAL';

// Consult Now
export const SHOW_CONSULT_NOW_INVITATION = 'SHOW_CONSULT_NOW_INVITATION';
export const SHOW_CANCEL_CONSULT_NOW_INVITATION_MODAL = 'SHOW_CANCEL_CONSULT_NOW_INVITATION_MODAL';
export const SHOW_EXTEND_CONSULT_NOW_INVITATION_MODAL = 'SHOW_EXTEND_CONSULT_NOW_INVITATION_MODAL';

// group consultation settings
export const SHOW_GC_SETTINGS_MODAL = 'SHOW_GC_SETTINGS_MODAL';
export const SHOW_OU_DEFAULT_GC_SETTINGS_MODAL = 'SHOW_OU_DEFAULT_GC_SETTINGS_MODAL';
export const SHOW_OU_WA_GC_SETTINGS_MODAL = 'SHOW_OU_WA_GC_SETTINGS_MODAL';

// Delete Organization
export const SHOW_DELETE_ORGANIZATION_MODAL = 'SHOW_DELETE_ORGANIZATION_MODAL';

export function showModal(modalSelector) {
  return (dispatch) => {
    setTimeout(() => {
      window.$(modalSelector).modal({ closable: false }).modal('show');
    }, 50);
    return dispatch({ type: SHOW_MODAL });
  };
}
export function hideModal(modalSelector) {
  return (dispatch) => {
    setTimeout(() => {
      return dispatch({ type: HIDE_MODAL });
    }, 350);
    window.$(modalSelector).modal('hide');
  };
}

export function updateHideWhenClickAwayQuickView(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_HIDE_WHEN_CLICK_AWAY_QUICK_VIEW,
      data: hideOrNot,
    });
  };
}

export function updateShowQuickViewModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: UPDATED_SHOW_QUICK_VIEW_MODAL, data: hideOrNot });
  };
}

export function updateShowCreateMeetingRoomModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_CREATE_MEETING_ROOM_MODAL,
      data: hideOrNot,
    });
  };
}
export function updateShowMeetingRoomParticipant(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_VIEW_MEETING_ROOM_PARTICIPANT,
      data: hideOrNot,
    });
  };
}

// Edit meeting room Properties
export function showEditMeetingRoomModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_EDIT_MEETING_ROOM_MODAL, data: hideOrNot });
  };
}

export function updateShowWebsiteButtonWaitingArea(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_WEBSITE_BUTTON_WAITING_AREA_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowViewMeetingRoomModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_VIEW_MEETING_ROOM_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowUpdateMeetingRoomModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_UPDATE_MEETING_ROOM_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowDeleteMeetingRoomModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_DELETE_MEETING_ROOM_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowAddToCallWaitingAreaModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_ADD_TO_CALL_WAITING_ARE_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowWaitingAreaParticipant(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_VIEW_WAITING_AREA_PARTICIPANT,
      data: hideOrNot,
    });
  };
}

export function updateShowNotifyRoomParticipant(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_NOTIFY_ROOM_PARTICIPANT,
      data: hideOrNot,
    });
  };
}

export function showShowCallHistoryModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_CALL_HISTORY_MODAL, data: hideOrNot });
  };
}

export function updateShowforgetPasswordModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATE_SHOW_FORGET_PASSWORD_MODAL,
      data: hideOrNot,
    });
  };
}
export function updateShowResetPasswordTokenModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATE_SHOW_RESET_PASSWORD_TOKEN_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowChangePasswordModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATE_SHOW_CHANGE_PASSWORD_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowChangeEmailModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATE_SHOW_CHANGE_EMAIL_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowChangeEmailSuccessModal(hideOrNot) {
  return (dispatch) => {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('serverClientTimeDiffMilliSeconds');
    window.localStorage.removeItem('startDateForReport');
    window.localStorage.removeItem('endDateForReport');
    window.localStorage.removeItem('queuedEvents');
    window.localStorage.removeItem('unsentEvents');
    disposePubNub();
    reportInitialState.startDate = null;
    reportInitialState.endDate = null;
    return dispatch({
      type: UPDATE_SHOW_CHANGE_EMAIL_SUCCESS_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowUserProfileModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_SHOW_USER_PROFILE_MODAL, data: hideOrNot });
  };
}
export function updateShowInviteGuestModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_SHOW_INVITE_GUEST_MODAL, data: hideOrNot });
  };
}

export function updateShowCreateWaitingAreaModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_CREATE_WAITING_AREA_MODAL,
      data: hideOrNot,
    });
  };
}

export function showDeleteOrganizationModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_DELETE_ORGANIZATION_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowUpdateWaitingAreaModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_UPDATE_WAITING_AREA_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowViewWaitingAreaModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_VIEW_WAITING_AREA_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowViewWaitingAreaOperatingHoursModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_VIEW_WAITING_AREA_OPERATING_HOURS_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowUpdateWaitingAreaOperatingHoursModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_UPDATE_WAITING_AREA_OPERATING_HOURS_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowViewWaitingAreaLocalAccessHoursModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_VIEW_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL,
      data: hideOrNot,
    });
  };
}

export function showWaitingAreaLogoPauseImageModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_WAITING_AREA_LOGO_PAUSE_IMAGE_MODAL,
      data: hideOrNot,
    });
  };
}

export function showOrganisationalUnitLogoImageModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_ORGANISATIONAL_UNIT_LOGO_IMAGE_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowUpdateWaitingAreaLocalAccessHoursModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowUpdateSmsNotificationModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_UPDATE_SMS_NOTIFICATION,
      data: hideOrNot,
    });
  };
}

export function updateShowCreateSmsNotificatioModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_CREATE_SMS_NOTIFICATION,
      data: hideOrNot,
    });
  };
}

export function updateShowSetMinDurationsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATE_SHOW_SET_MIN_DURATIONS_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowSuspendWAModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_SHOW_SUSPEND_WA_MODAL, data: hideOrNot });
  };
}

export function showWAShareLinkMessageModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_SHOW_WA_SHARE_LINK_MSG_MODAL, data: hideOrNot });
  };
}

export function updateShowWaitingAreaBeforeCallsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowWaitingAreaBeforeCallsImportantInfoModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO_MODAL,
      data: hideOrNot,
    });
  };
}

export function showWaitingAreaDuringCallsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_SHOW_DURING_CALLS_MODAL, data: hideOrNot });
  };
}

// Caller Entry Point
export function showCallerEntryModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_SHOW_CALLER_ENTRY_POINT, data: hideOrNot });
  };
}

export function showWaitingAreaAfterCallsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_WAITING_AREA_AFTER_CALLS_MODAL,
      data: hideOrNot,
    });
  };
}

export function showConsultNowSettingModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_CONSULT_NOW_SETTING_MODAL,
      data: hideOrNot,
    });
  };
}
export function showWAAudioSettingModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_WA_AUDIO_SETTING_MODAL,
      data: hideOrNot,
    });
  };
}
/********************************* Meeting Rooms **************************************/
//Copy URL to clipboard
export function showCopyLinkToClipboardForMeetingRoom(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_COPY_LINK_TO_CLIPBOARD_MODAL_FOR_MEETING_ROOM,
      data: hideOrNot,
    });
  };
}

export function showHideWaitingAreaAddUsersModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_WAITING_AREA_ADD_USER_MODAL,
      data: hideOrNot,
    });
  };
}
export function showHideOrganisationalUnitAddUsersModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_ORGANISATIONAL_UNIT_ADD_USER_MODAL,
      data: hideOrNot,
    });
  };
}
// Manage roles in users list
export function showManageRolesModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_MANAGE_ROLES_FOR_USERS, data: hideOrNot });
  };
}

// Manage roles in users list
export function showOrgManageRolesModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_ORG_MANAGE_ROLES_FOR_USERS, data: hideOrNot });
  };
}

export function showWAInviteSelfProvison(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_VIEW_WA_INVITE_SELF_PROVISION,
      data: hideOrNot,
    });
  };
}
export function editPortalSettingModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: EDIT_UPDATE_PORTAL_SETTING,
      data: hideOrNot,
    });
  };
}

export function updateShowRegisterUserWithWA(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_REGISTERED_USER_WITH_WA_MODAL,
      data: hideOrNot,
    });
  };
}

export function updateShowWelcomeWAMessage(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_SHOW_WA_WELCOME_MODAL,
      data: hideOrNot,
    });
  };
}

// Support Contact
export function showSupportContactModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_SUPPORT_CONTACT_MODAL,
      data: {
        showSupportContactModal: hideOrNot,
      },
    });
  };
}

export function showInfoForCallersModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_INFO_FOR_CALLERS_MODAL,
      data: {
        showInfoForCallersModal: hideOrNot,
      },
    });
  };
}

// Deactivate WA
export function showDeleteWaitingAreaModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_DELETE_WA_MODAL,
      data: hideOrNot,
    });
  };
}

export function closeModalsForPiwa() {
  // PiWA
  // This function will close all modal dialogue on PIWA
  // If any one of the dialogues are open and disappear due to WA is deleted
  // Those open dialogue should closed by calling this method.
  return (dispatch) => {
    dispatch(updateShowAddToCallWaitingAreaModal(false));
    dispatch(updateShowWaitingAreaParticipant(false));
    dispatch(updateShowNotifyRoomParticipant(false));
    dispatch(showShowCallHistoryModal(false));
    dispatch(updateShowUpdateWaitingAreaModal(false));
    dispatch(updateShowViewWaitingAreaModal(false));
    dispatch(updateShowViewWaitingAreaOperatingHoursModal(false));
    dispatch(updateShowUpdateWaitingAreaOperatingHoursModal(false));
    dispatch(updateShowViewWaitingAreaLocalAccessHoursModal(false));
    dispatch(updateShowUpdateWaitingAreaLocalAccessHoursModal(false));
    dispatch(showWaitingAreaLogoPauseImageModal(false));
    dispatch(updateShowUpdateSmsNotificationModal(false));
    dispatch(updateShowCreateSmsNotificatioModal(false));
    dispatch(updateShowSuspendWAModal(false));
    dispatch(updateShowWaitingAreaBeforeCallsModal(false));
    dispatch(updateShowWaitingAreaBeforeCallsImportantInfoModal(false));
    dispatch(showWaitingAreaDuringCallsModal(false));
    dispatch(showCallerEntryModal(false));
    dispatch(showWaitingAreaAfterCallsModal(false));
    dispatch(showSupportContactModal(false));
    dispatch(showDeleteWaitingAreaModal(false));
    dispatch(showShareByEmailModal(false));
    dispatch(showShareByTextModal(false));
    dispatch(showInfoForCallersModal(false));
  };
}

export function closeModalsForWAManageUsers() {
  // Manage users
  // This function will close all modal dialogue on Waiting area manage user page
  // If any one of the dialogues are open and disappear due to WA is deleted
  // Those open dialogue should closed by calling this method.
  return (dispatch) => {
    dispatch(showHideWaitingAreaAddUsersModal(false));
    dispatch(showManageRolesModal(false));
  };
}

export function closeModalsForWAManageTags() {
  // Manage reporting tags
  // This function will close all modal dialogue on Waiting area manage tags page
  // If any one of the dialogues are open and disappear due to WA is deleted
  // Those open dialogue should closed by calling this method.
  return (dispatch) => {
    dispatch(showDeleteTagFromWAConfirmationModal(false));
    dispatch(showAssignTagsModal(false));
    dispatch(showEditTagValueModal(false));
  };
}

// Manage tags
export function showDeleteTagFromWAConfirmationModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_REMOVE_TAG_CONFIRMATION_MODAL,
      data: hideOrNot,
    });
  };
}

export function showAssignTagsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_ASSIGN_TAGS_MODAL, data: hideOrNot });
  };
}

export function showEditTagValueModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_EDIT_TAG_VALUE_MODAL, data: hideOrNot });
  };
}

// OU Manage Tags
export function showDeleteTagFromOUConfirmationModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_REMOVE_TAG_CONFIRMATION_MODAL_IN_OU,
      data: hideOrNot,
    });
  };
}

export function showAssignTagsModalFromOU(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_ASSIGN_TAGS_MODAL_IN_OU, data: hideOrNot });
  };
}

export function showEditTagValueModalFromOU(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_EDIT_TAG_VALUE_MODAL_IN_OU, data: hideOrNot });
  };
}

export function showMyRolesModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: UPDATED_SHOW_MY_ROLES_MODAL, data: hideOrNot });
  };
}

/********************************* Org Units **************************************/
export function showOrgUnitGeneralInfoModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_ORG_UNIT_GENERAL_INFO_MODALS,
      data: hideOrNot,
    });
  };
}

export function showOrgUnitSupportContactModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_ORG_UNIT_SUPPORT_CONTACT_MODAL,
      data: hideOrNot,
    });
  };
}

export function showOrgUnitBeforeCallsForWA(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_ORG_UNIT_BEFORE_CALLS_WA_MODAL,
      data: hideOrNot,
    });
  };
}

export function showOrgUnitShareLinkForWAModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_ORG_UNIT_SHARE_LINK_WA_MODAL,
      data: hideOrNot,
    });
  };
}

// Reset Meeting Room Guest Link
export function showResetGuestLinkModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_MEETING_ROOM_RESET_GUEST_LINK_MODAL,
      data: hideOrNot,
    });
  };
}

// Meeting Room Add Users
export function showHideMeetingRoomAddUsersModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_MEETING_ROOM_ADD_USERS_MODAL,
      data: hideOrNot,
    });
  };
}

export function showMRManageRolesModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_MR_MANAGE_ROLES_FOR_USERS, data: hideOrNot });
  };
}

// Manage all Users listing page
export function updateShowOtherUserProfileModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_OTHER_USERS_PROFILE, data: hideOrNot });
  };
}

// Show other user's roles
export function showOtherUserRolesModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_OTHER_USERS_ROLES, data: hideOrNot });
  };
}

// Manage Invitations
export function showManageInvitationsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_MANAGE_INVITATIONS_MODAL, data: hideOrNot });
  };
}

// Create OU
export function showCreateOUModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_CREATE_OU_MODAL, data: hideOrNot });
  };
}

// Share URL in PiWA
export function showShareByEmailModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_SHARE_BY_EMAIL_WA, data: hideOrNot });
  };
}

export function showShareByTextModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_SHARE_BY_TEXT_WA, data: hideOrNot });
  };
}

export function showConfirmationCallMessModal(hideOrNot, successAction, participants, confirmationCallMessActionType) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_CONFIRMATION_CALL_MESS_MODAL,
      data: hideOrNot,
      successAction,
      participants,
      confirmationCallMessActionType,
    });
  };
}

// Consutl now
export function showSendConsultNowInvitationModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_CONSULT_NOW_INVITATION, data: hideOrNot });
  };
}

export function showCancelCNInvtiationModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_CANCEL_CONSULT_NOW_INVITATION_MODAL, data: hideOrNot });
  };
}

export function showExtendCNInvtiationModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({ type: SHOW_EXTEND_CONSULT_NOW_INVITATION_MODAL, data: hideOrNot });
  };
}

// RECORDING
export function showOURecordingSettingModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_RECORDING_SETTING_MODAL,
      data: hideOrNot,
    });
  };
}

// OU DEFAULT GC CHAT-FULLNAME CONTROL MODAL
export function showOuDefaultGcSettingsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_OU_DEFAULT_GC_SETTINGS_MODAL,
      data: hideOrNot,
    });
  };
}

// OU WA SETTING GC CHAT-FULLNAME CONTROL MODAL
export function showOuWaGcSettingsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_OU_WA_GC_SETTINGS_MODAL,
      data: hideOrNot,
    });
  };
}
// WA-VIEWONE GC settings
export function showGCSettingsModal(hideOrNot) {
  return (dispatch) => {
    return dispatch({
      type: SHOW_GC_SETTINGS_MODAL,
      data: hideOrNot,
    });
  };
}
